import RemoveChartModal from './RemoveChartModal';

export default RemoveChartModal;
